export function IconStatClients() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="16" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M4 19C4 16 6 14 9 14" stroke="currentColor" strokeWidth="1.8" />
      <path d="M14 19C14 17 15.5 15.5 17.5 15.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M20 19C20 17.2 18.8 16 17 16" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  )
}

export function IconStatCountries() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path d="M3 12H21" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 3C15 7 15 17 12 21C9 17 9 7 12 3Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  )
}

export function IconStatDeliveries() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M8 12L11 15L13 13L16 16L20 12" stroke="currentColor" strokeWidth="1.8" />
      <path d="M4 8L8 12M20 8L16 12" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  )
}

export function IconStatExperience() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2L20 6V12C20 17 16.5 20.5 12 22C7.5 20.5 4 17 4 12V6L12 2Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  )
}

export function IconCheck() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6 12L10 16L18 8"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
